import { parseStartDate, parseEndDate } from '../utils/parseDate';

const formatHistoryDataWs = rec => {
    const {
        createDate: addedAt,
        endDate,
        userFirstName: firstName,
        createDateReportIdSortKey: id,
        isGumGumUser,
        userLastName: lastName,
        name,
        orderBy,
        rightsholdersId,
        rightsholderIds,
        rightsholdersIds,
        rightsholdersName,
        rightsholderNames,
        placementId,
        placementName,
        sponsorId,
        sponsorIds,
        sponsorName,
        startDate,
        url,
        goal,
        goalName,
        broadcastCountryIds,
        broadcastCountryNames,
        userEmail,
        useRightsholderAttribution,
    } = rec;

    //Naming convention for rightsholderIds is not consistent
    //This has been changed lately to rightsholderIds to keep consistency with sent data
    const _rightsholderIds =
        rightsholdersId || rightsholderIds || rightsholdersIds;
    const rightsholderIdsArray = _rightsholderIds
        ? _rightsholderIds.split(',')
        : [];
    const multipleRh = rightsholderIdsArray.length > 1;
    const createdBy = isGumGumUser ? 'Relo' : `${firstName} ${lastName}`;

    const start = startDate && parseStartDate(startDate);

    const end = endDate && parseEndDate(endDate);

    const exportAs =
        url && url.match(/\.[a-z]*$/)[0] === '.pdf' ? 'pdf' : 'powerpoint';
    const hasPlacement = placementName && placementName != 'false';
    const pl = placementId ? placementId.split('-')[1] : null;

    const row = {
        addedAt,
        createdBy,
        endDate: end,
        startDate: start,
        exportAs,
        name,
        id,
        orderBy,
        rightsholder:
            multipleRh || rightsholderIds ? rightsholderIds : rightsholdersId,
        rightsholderName: multipleRh
            ? `${rightsholderIdsArray.length} Rightsholders`
            : rightsholdersName || (rightsholderNames && rightsholderNames[0]),
        sponsor: sponsorIds ? sponsorIds : [sponsorId],
        sponsorName: sponsorName,
        placement: hasPlacement ? parseInt(pl) : null,
        placementName: hasPlacement ? placementName : null,
        reportUrl: url,
        userEmail: userEmail,
        goal,
        goalName,
        broadcastCountryIds,
        broadcastCountryNames,
        useRightsholderAttribution: useRightsholderAttribution ?? false,
    };
    return row;
};

export default formatHistoryDataWs;
